import { render, staticRenderFns } from "./ForestersWholeFR2.vue?vue&type=template&id=ace2b90e&scoped=true"
import script from "./ForestersWholeFR2.vue?vue&type=script&lang=js"
export * from "./ForestersWholeFR2.vue?vue&type=script&lang=js"
import style0 from "./ForestersWholeFR2.vue?vue&type=style&index=0&id=ace2b90e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace2b90e",
  null
  
)

export default component.exports